import { Field, Formik } from "formik";
import { flow, get, isEmpty } from "lodash";
import React, { useContext, useState } from "react";
import { Form } from "react-bootstrap";
import months from "../../../mocks/months.json";
import weekdays from "../../../mocks/weekdays.json";
import {
  DatePicker,
  DayDropdown,
  FieldButtonGroup,
  FieldDropSide,
  FieldInputNumber,
  LoaderWrapper,
  ManageFeeLayout,
  SearchableList,
  TimePicker,
} from "../../../components";
import {
  FLOW_TYPES,
  formFields,
  getAdvancedPathWithParam,
  getPathWithParam,
  manageFeeFormNames,
  MANAGE_FEE_ROUTES,
  OPTIONS_DATA_MAPPER,
  ROUTES,
  toOptionValuesFromMapper,
  usDateFormat,
} from "../../../utils";
import { useDeepEffect, useRouterParams } from "../../../abstracts";
import { AddFeeSchedule, GetFeeSchedule } from "../../../services";
import {
  manageFeeStore,
  setFeeIdInfo,
  setFeeIsLoading,
  setScheduleData,
} from "../../../contexts";
import { useHistory } from "react-router";

const ScheduleRunContainer = (props) => {
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const { flow, feeId } = useRouterParams();
  const isEdit = flow === FLOW_TYPES.EDIT;
  const isSave = flow === FLOW_TYPES.SAVE;
  const { state, dispatch } = useContext(manageFeeStore);
  const apiData = get(state, "api.data", {});
  const getScheduleDetails = get(apiData, "feeSchedule", {});
  const formName = manageFeeFormNames.SCHEDULE_OR_RUN;
  const fields = formFields[formName];
  const [errorMsg, setErrorMsg] = useState("");

  const buttons = [
    {
      label: "Cancel",
      variant: "secondary",
      type: "button",
      link: ROUTES.FEE,
      flow: [FLOW_TYPES.ADD],
    },
    {
      label: "Next",
      variant: "primary",
      type: "submit",
      flow: [FLOW_TYPES.ADD],
    },
  ];

  const editbuttons = [
    {
      label: "Cancel",
      variant: "secondary",
      type: "button",
      flow: [FLOW_TYPES.EDIT, FLOW_TYPES.SAVE],
      link: ROUTES.FEE,
    },
    {
      label: "Next",
      variant: "primary",
      type: "button",
      flow: [FLOW_TYPES.EDIT],
      onClick: () =>
        history.push(
          getAdvancedPathWithParam({
            path: MANAGE_FEE_ROUTES.SUMMARY,
            pathParam: [FLOW_TYPES.EDIT, feeId],
          })
        ),
    },
    // {
    //   label: "Edit",
    //   variant: "primary",
    //   type: "button",
    //   flow: [FLOW_TYPES.EDIT],
    //   onClick: () =>
    //     history.push(
    //       getAdvancedPathWithParam({
    //         path: MANAGE_FEE_ROUTES.SCHEDULE_OR_RUN,
    //         pathParam: [FLOW_TYPES.SAVE, feeId],
    //       })
    //     ),
    // },
    {
      label: "Save & Proceed",
      variant: "primary",
      type: "submit",
      flow: [FLOW_TYPES.SAVE],
    },
  ];

  const initialValues = {};
  useDeepEffect(() => {
    //if (feeId && isEmpty(getScheduleDetails)) {
    dispatch(setFeeIsLoading(true));
    GetFeeSchedule(feeId).then((res) => {
      if (res.isSuccessfull) {
        dispatch(setScheduleData(res));
        dispatch(
          setFeeIdInfo({
            id: res.feeSchedule.feeId,
            step: res.feeSchedule.step,
          })
        );
      }
    });
    //}
  }, []);

  const onFormSubmit = (values, { setFieldError, setFieldTouched }) => {
    setIsLoading(true);
    AddFeeSchedule({
      ...values,
      schedule: {
        scheduleType: values.scheduleType,
        monthAnnually: values.monthAnnually,
        dayAnnually: values.dayAnnually,
        monthSemiAnnually: values.monthSemiAnnually,
        daySemiAnnually: values.daySemiAnnually,
        startDay: values.startDay,
        firstDate: values.firstDate,
        secondDate: values.secondDate,
        monthQuarterly: values.monthQuarterly,
        dayQuarterly: values.dayQuarterly,
        startDayWeekly: values.startDayWeekly,
      },
      feeId: parseInt(feeId),
      step: 4,
    })
      .then((res) => {
        if (res.isSuccessfull) {
          setIsLoading(false);
          var payload = {
            isSuccessfull: res.isSuccessfull,
            feeSchedule: res.feeSchedule,
          };
          dispatch(setScheduleData(payload));
          dispatch(
            setFeeIdInfo({
              id: res.feeSchedule.feeId,
              step: res.feeSchedule.step,
            })
          );
          history.push(
            getPathWithParam({
              path: MANAGE_FEE_ROUTES.SUMMARY,
              pathParam: [res.feeSchedule.feeId],
            })
          );
        } else {
          setIsLoading(false);
          setErrorMsg("");
          for (var i = 0; i < res.errorMessages.length; i++) {
            var _ = res.errorMessages[i];
            setFieldTouched(_.controlName, true);
            setFieldError(_.controlName, `${_.errorCode} : ${_.message}`);
            if (_.controlName === "processTimeHours") {
              setErrorMsg(`${_.errorCode} : ${_.message}`);
            }
          }
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  return (
    <LoaderWrapper isLoading={isLoading}>
      <Formik
        onSubmit={onFormSubmit}
        initialValues={{
          ...initialValues,
          [fields.feeRunType]: get(getScheduleDetails, "feeRunType", null),
          [fields.effectiveStartDate]: get(
            getScheduleDetails,
            "effectiveStartDate",
            null
          ),
          [fields.effectiveEndDate]: get(
            getScheduleDetails,
            "effectiveEndDate",
            null
          ),
          [fields.feeProcess]: get(getScheduleDetails, "feeProcess", null),
          [fields.processDate]: get(getScheduleDetails, "processDate", null),
          [fields.basisDate]: get(getScheduleDetails, "basisDate", null),
          [fields.basisAsOfDate]: get(
            getScheduleDetails,
            "basisAsOfDate",
            null
          ),
          [fields.basisAsOfFrequency]:
            get(getScheduleDetails, "basisAsOfFrequency") === null
              ? 1
              : get(getScheduleDetails, "basisAsOfFrequency"),
          [fields.scheduleType]: get(
            getScheduleDetails.schedule,
            "scheduleType",
            null
          ),
          [fields.monthAnnually]: get(
            getScheduleDetails.schedule,
            "monthAnnually",
            null
          ),
          [fields.dayAnnually]: get(
            getScheduleDetails.schedule,
            "dayAnnually",
            null
          ),
          [fields.monthSemiAnnually]: get(
            getScheduleDetails.schedule,
            "monthSemiAnnually",
            null
          ),
          [fields.daySemiAnnually]: get(
            getScheduleDetails.schedule,
            "daySemiAnnually",
            null
          ),
          [fields.startDay]: get(getScheduleDetails.schedule, "startDay", null),
          [fields.firstDate]: get(
            getScheduleDetails.schedule,
            "firstDate",
            null
          ),
          [fields.secondDate]: get(
            getScheduleDetails.schedule,
            "secondDate",
            null
          ),
          [fields.monthQuarterly]: get(
            getScheduleDetails.schedule,
            "monthQuarterly",
            null
          ),
          [fields.dayQuarterly]: get(
            getScheduleDetails.schedule,
            "dayQuarterly",
            null
          ),
          [fields.startDayWeekly]: get(
            getScheduleDetails.schedule,
            "startDayWeekly",
            null
          ),
          [fields.processTimeMinutes]:
            get(getScheduleDetails, "processTimeMinutes") === null
              ? null
              : get(getScheduleDetails, "processTimeMinutes"),
          [fields.processTimeHours]:
            get(getScheduleDetails, "processTimeHours") === null
              ? null
              : get(getScheduleDetails, "processTimeHours"),
        }}
        enableReinitialize
        validateOnChange={false}
        validateOnBlur={false}
      >
        {({
          handleChange,
          setFieldValue,
          setValues,
          setFieldError,
          setTouched,
          handleSubmit,
          setErrors,
          values,
          ...rest
        }) => {
          const onDaySelected = (fieldName, value) => {
            setFieldValue(fieldName, value);
          };
          const onFeeRubChange = (value) => {
            setFieldValue(fields.feeRunType, value);
            if (value !== 2) {
              setFieldValue(fields.effectiveStartDate, null);
              setFieldValue(fields.effectiveEndDate, null);
              setFieldValue(fields.scheduleType, null);
              setFieldValue(fields.monthAnnually, null);
              setFieldValue(fields.dayAnnually, null);
              setFieldValue(fields.monthSemiAnnually, null);
              setFieldValue(fields.daySemiAnnually, null);
              setFieldValue(fields.startDay, null);
              setFieldValue(fields.firstDate, null);
              setFieldValue(fields.secondDate, null);
              setFieldValue(fields.monthQuarterly, null);
              setFieldValue(fields.dayQuarterly, null);
              setFieldValue(fields.startDayWeekly, null);
              if (values[fields.feeProcess] === null) {
                setFieldValue(fields.processTimeMinutes, null);
                setFieldValue(fields.processTimeHours, null);
              }
            }
            if (value !== 1) {
              setFieldValue(fields.feeProcess, null);
            }
          };

          const onBasisDateChange = (value) => {
            setFieldValue(fields.basisDate, value);
            if (value !== 2) {
              setFieldValue(fields.basisAsOfDate, null);
            }
          };

          const onScheduleTypeChange = (value) => {
            setFieldValue(fields.scheduleType, value);
            if (value !== 1) {
              setFieldValue(fields.monthAnnually, null);
              setFieldValue(fields.dayAnnually, null);
            }
            if (value !== 2) {
              setFieldValue(fields.monthSemiAnnually, null);
              setFieldValue(fields.daySemiAnnually, null);
            }
            if (value !== 3) {
              setFieldValue(fields.startDay, null);
            }
            if (value !== 4) {
              setFieldValue(fields.firstDate, null);
              setFieldValue(fields.secondDate, null);
            }
            if (value !== 5) {
              setFieldValue(fields.monthQuarterly, null);
              setFieldValue(fields.dayQuarterly, null);
            }
            if (value !== 6) {
              setFieldValue(fields.startDayWeekly, null);
            }
          };

          return (
            <Form
              autoComplete="off"
              className="h-100"
              onSubmit={handleSubmit}
              validated={!isEmpty(rest.errors)}
            >
              <ManageFeeLayout
                isCreateFee={true}
                layoutHeader={"Schedule / Run"}
                buttons={
                  get(getScheduleDetails, "step") >= 5 ? editbuttons : buttons
                }
                pageFlow={flow}
              >
                <div className="addedPlans-card-font mb-10">Fee run </div>
                <Field
                  isRequired
                  name={fields.feeRunType}
                  options={toOptionValuesFromMapper(
                    OPTIONS_DATA_MAPPER.FEE_RUN
                  )}
                  selectedValue={values[fields.feeRunType]}
                  value={values[fields.feeRunType]}
                  onChange={(value) => {
                    onFeeRubChange(value);
                  }}
                  component={FieldButtonGroup}
                  disabled={get(getScheduleDetails, "step") >= 5}
                  size="smd"
                />
                {values[fields.feeRunType] === 1 && (
                  <>
                    <div className="addedPlans-card-font mb-10">
                      Fee Process
                    </div>
                    <Field
                      isRequired
                      name={fields.feeProcess}
                      options={toOptionValuesFromMapper(
                        OPTIONS_DATA_MAPPER.FEE_PROCESS
                      )}
                      selectedValue={values[fields.feeProcess]}
                      value={values[fields.feeProcess]}
                      onChange={(value) => {
                        setFieldValue(fields.feeProcess, value);
                        if (value !== 2) {
                          setFieldValue(fields.processDate, null);
                        }
                      }}
                      component={FieldButtonGroup}
                      disabled={isEdit && !isSave}
                      size="smd"
                    />
                  </>
                )}
                {values[fields.feeRunType] === 2 && (
                  <>
                    <div className="addedPlans-card-font mb-10">
                      Effective date
                    </div>
                    <Field
                      size="sm"
                      isRequired
                      name={fields.effectiveStartDate}
                      value={usDateFormat(values[fields.effectiveStartDate])}
                      direction="bottom"
                      isDatePicker
                      onClear={() =>
                        setFieldValue(fields.effectiveStartDate, null)
                      }
                      popupContent={
                        <DatePicker
                          onDayClick={(value) =>
                            onDaySelected(fields.effectiveStartDate, value)
                          }
                          value={usDateFormat(
                            values[fields.effectiveStartDate]
                          )}
                        />
                      }
                      component={FieldDropSide}
                      disabled={isEdit && !isSave}
                    />
                    <div className="addedPlans-card-font mb-10">
                      Fee end date
                    </div>
                    <Field
                      size="sm"
                      isRequired
                      name={fields.effectiveEndDate}
                      value={usDateFormat(values[fields.effectiveEndDate])}
                      direction="bottom"
                      isDatePicker
                      onClear={() =>
                        setFieldValue(fields.effectiveEndDate, null)
                      }
                      popupContent={
                        <DatePicker
                          onDayClick={(value) =>
                            onDaySelected(fields.effectiveEndDate, value)
                          }
                          value={usDateFormat(values[fields.effectiveEndDate])}
                        />
                      }
                      component={FieldDropSide}
                      disabled={isEdit && !isSave}
                    />
                  </>
                )}
                {values[fields.feeProcess] === 2 && (
                  <>
                    <div className="addedPlans-card-font mb-10">
                      Process Date
                    </div>
                    <Field
                      size="sm"
                      isRequired
                      name={fields.processDate}
                      value={usDateFormat(values[fields.processDate])}
                      direction="right"
                      onClear={() => setFieldValue(fields.processDate, null)}
                      popupContent={
                        <DatePicker
                          onDayClick={(value) =>
                            onDaySelected(fields.processDate, value)
                          }
                          value={usDateFormat(values[fields.processDate])}
                        />
                      }
                      component={FieldDropSide}
                      disabled={isEdit && !isSave}
                      offset={100}
                    />
                  </>
                )}
                <div className="addedPlans-card-font mb-10">
                  Basis as of date
                </div>
                <Field
                  isRequired
                  name={fields.basisDate}
                  options={toOptionValuesFromMapper(
                    OPTIONS_DATA_MAPPER.BASIS_OF_DATE
                  )}
                  selectedValue={values[fields.basisDate]}
                  value={values[fields.basisDate]}
                  onChange={(value) => {
                    onBasisDateChange(value);
                  }}
                  component={FieldButtonGroup}
                  disabled={isEdit && !isSave}
                  size="smd"
                />

                {values[fields.basisDate] === 2 && (
                  <>
                    <div className="addedPlans-card-font mb-10">
                      Basis as of other
                    </div>
                    <div className="d-flex">
                      <Field
                        size="xxs"
                        isRequired
                        name={fields.basisAsOfDate}
                        type="number"
                        autoComplete="off"
                        value={values[fields.basisAsOfDate]}
                        onChange={handleChange}
                        disabled={isEdit && !isSave}
                        component={FieldInputNumber}
                      />
                      &nbsp;&nbsp;&nbsp;
                      <div
                        style={{
                          marginLeft: "1rem",
                        }}
                      >
                        <Field
                          size="sm"
                          isRequired
                          name={fields.basisAsOfFrequency}
                          value={values[fields.basisAsOfFrequency]}
                          options={toOptionValuesFromMapper(
                            OPTIONS_DATA_MAPPER.BASIS_FREQUENCY
                          )}
                          placeholder="Select"
                          direction="right"
                          popupContent={
                            <SearchableList
                              label="Select"
                              overflow
                              options={toOptionValuesFromMapper(
                                OPTIONS_DATA_MAPPER.BASIS_FREQUENCY
                              )}
                              onSelect={(value) => {
                                setFieldValue(fields.basisAsOfFrequency, value);
                              }}
                              selectedValue={values[fields.basisAsOfFrequency]}
                            />
                          }
                          component={FieldDropSide}
                          disabled={isEdit && !isSave}
                        />
                      </div>
                    </div>
                  </>
                )}
                {values[fields.feeRunType] === 2 && (
                  <>
                    <div className="Fee-section-head">Schedule</div>
                    <div className="addedPlans-card-font mb-10">
                      Schedule frequency{" "}
                    </div>
                    <Field
                      size="md"
                      isRequired
                      name={fields.scheduleType}
                      value={values[fields.scheduleType]}
                      options={toOptionValuesFromMapper(
                        OPTIONS_DATA_MAPPER.FEE_FREQUENCY
                      )}
                      placeholder="Select"
                      direction="right"
                      popupContent={
                        <SearchableList
                          label="Select"
                          overflow
                          options={toOptionValuesFromMapper(
                            OPTIONS_DATA_MAPPER.FEE_FREQUENCY
                          )}
                          onSelect={(value) => {
                            onScheduleTypeChange(value);
                          }}
                          selectedValue={values[fields.scheduleType]}
                        />
                      }
                      component={FieldDropSide}
                      disabled={isEdit && !isSave}
                    />

                    {values[fields.scheduleType] === 1 && (
                      <>
                        <div className="addedPlans-card-font mb-10">
                          Starting month
                        </div>
                        <Field
                          size="md"
                          isRequired
                          name={fields.monthAnnually}
                          value={values[fields.monthAnnually]}
                          options={months.data}
                          placeholder="Select"
                          direction="right"
                          popupContent={
                            <SearchableList
                              label="Select"
                              height="10rem"
                              options={months.data}
                              onSelect={(value) => {
                                setFieldValue(fields.monthAnnually, value);
                              }}
                              selectedValue={values[fields.monthAnnually]}
                            />
                          }
                          component={FieldDropSide}
                          disabled={isEdit && !isSave}
                        />
                        <div className="addedPlans-card-font mb-10">
                          Day of the month
                        </div>
                        <Field
                          size="md"
                          name={fields.dayAnnually}
                          placeholder="Date"
                          value={values[fields.dayAnnually]}
                          disabled={isEdit && !isSave}
                          direction="right"
                          popupContent={
                            <DayDropdown
                              fromMonthDate={
                                new Date(
                                  2020,
                                  values[fields.dayAnnually] - 1 || 0
                                )
                              }
                              onSelect={(value) =>
                                setFieldValue(
                                  fields.dayAnnually,
                                  parseInt(value, 10)
                                )
                              }
                              value={values[fields.dayAnnually]}
                            />
                          }
                          component={FieldDropSide}
                          offset={100}
                        />
                      </>
                    )}

                    {values[fields.scheduleType] === 2 && (
                      <>
                        <div className="addedPlans-card-font mb-10">
                          Starting month of the half year
                        </div>
                        <Field
                          size="md"
                          isRequired
                          name={fields.monthSemiAnnually}
                          value={values[fields.monthSemiAnnually]}
                          options={months.data}
                          placeholder="Select"
                          direction="right"
                          popupContent={
                            <SearchableList
                              label="Select"
                              height="10rem"
                              options={months.data}
                              onSelect={(value) => {
                                setFieldValue(fields.monthSemiAnnually, value);
                              }}
                              selectedValue={values[fields.monthSemiAnnually]}
                            />
                          }
                          component={FieldDropSide}
                          disabled={isEdit && !isSave}
                        />
                        <div className="addedPlans-card-font mb-10">
                          Day of the month
                        </div>
                        <Field
                          size="md"
                          name={fields.daySemiAnnually}
                          placeholder="Date"
                          value={values[fields.daySemiAnnually]}
                          disabled={isEdit && !isSave}
                          direction="right"
                          popupContent={
                            <DayDropdown
                              fromMonthDate={
                                new Date(
                                  2020,
                                  values[fields.daySemiAnnually] - 1 || 0
                                )
                              }
                              onSelect={(value) =>
                                setFieldValue(
                                  fields.daySemiAnnually,
                                  parseInt(value, 10)
                                )
                              }
                              value={values[fields.daySemiAnnually]}
                            />
                          }
                          component={FieldDropSide}
                          offset={100}
                        />
                      </>
                    )}

                    {values[fields.scheduleType] === 3 && (
                      <>
                        <div className="addedPlans-card-font mb-10">
                          Start day of every month
                        </div>
                        <Field
                          size="md"
                          name={fields.startDay}
                          placeholder="Date"
                          value={values[fields.startDay]}
                          disabled={isEdit && !isSave}
                          direction="right"
                          popupContent={
                            <DayDropdown
                              fromMonthDate={
                                new Date(2020, values[fields.startDay] - 1 || 0)
                              }
                              onSelect={(value) =>
                                setFieldValue(
                                  fields.startDay,
                                  parseInt(value, 10)
                                )
                              }
                              value={values[fields.startDay]}
                            />
                          }
                          component={FieldDropSide}
                          offset={100}
                        />
                      </>
                    )}

                    {values[fields.scheduleType] === 4 && (
                      <>
                        <div className="addedPlans-card-font mb-10">
                          First Begin Date
                        </div>
                        <Field
                          size="md"
                          name={fields.firstDate}
                          placeholder="Date"
                          value={values[fields.firstDate]}
                          disabled={isEdit && !isSave}
                          direction="right"
                          popupContent={
                            <DayDropdown
                              fromMonthDate={
                                new Date(
                                  2020,
                                  values[fields.firstDate] - 1 || 0
                                )
                              }
                              onSelect={(value) =>
                                setFieldValue(
                                  fields.firstDate,
                                  parseInt(value, 10)
                                )
                              }
                              value={values[fields.firstDate]}
                            />
                          }
                          component={FieldDropSide}
                          offset={100}
                        />
                        <div className="addedPlans-card-font mb-10">
                          Second Begin Date
                        </div>
                        <Field
                          size="md"
                          name={fields.secondDate}
                          placeholder="Date"
                          value={values[fields.secondDate]}
                          disabled={isEdit && !isSave}
                          direction="right"
                          popupContent={
                            <DayDropdown
                              fromMonthDate={
                                new Date(
                                  2020,
                                  values[fields.secondDate] - 1 || 0
                                )
                              }
                              onSelect={(value) =>
                                setFieldValue(
                                  fields.secondDate,
                                  parseInt(value, 10)
                                )
                              }
                              value={values[fields.secondDate]}
                            />
                          }
                          component={FieldDropSide}
                          offset={100}
                        />
                      </>
                    )}

                    {values[fields.scheduleType] === 5 && (
                      <>
                        <div className="addedPlans-card-font mb-10">
                          Starting month for the first quarter
                        </div>
                        <Field
                          size="md"
                          isRequired
                          name={fields.monthQuarterly}
                          value={values[fields.monthQuarterly]}
                          options={months.data}
                          placeholder="Select"
                          direction="right"
                          popupContent={
                            <SearchableList
                              label="Select"
                              height="10rem"
                              options={months.data}
                              onSelect={(value) => {
                                setFieldValue(fields.monthQuarterly, value);
                              }}
                              selectedValue={values[fields.monthQuarterly]}
                            />
                          }
                          component={FieldDropSide}
                          disabled={isEdit && !isSave}
                        />
                        <div className="addedPlans-card-font mb-10">
                          Day of the month
                        </div>
                        <Field
                          size="md"
                          name={fields.dayQuarterly}
                          placeholder="Date"
                          value={values[fields.dayQuarterly]}
                          disabled={isEdit && !isSave}
                          direction="right"
                          popupContent={
                            <DayDropdown
                              fromMonthDate={
                                new Date(
                                  2020,
                                  values[fields.dayQuarterly] - 1 || 0
                                )
                              }
                              onSelect={(value) =>
                                setFieldValue(
                                  fields.dayQuarterly,
                                  parseInt(value, 10)
                                )
                              }
                              value={values[fields.dayQuarterly]}
                            />
                          }
                          component={FieldDropSide}
                          offset={100}
                        />
                      </>
                    )}

                    {values[fields.scheduleType] === 6 && (
                      <>
                        <div className="addedPlans-card-font mb-10">
                          Startday
                        </div>
                        <Field
                          size="md"
                          isRequired
                          name={fields.startDayWeekly}
                          value={values[fields.startDayWeekly]}
                          options={weekdays.data}
                          placeholder="Select"
                          direction="right"
                          popupContent={
                            <SearchableList
                              label="Select"
                              overflow
                              options={weekdays.data}
                              onSelect={(value) => {
                                setFieldValue(fields.startDayWeekly, value);
                              }}
                              selectedValue={values[fields.startDayWeekly]}
                            />
                          }
                          component={FieldDropSide}
                          disabled={isEdit && !isSave}
                        />
                      </>
                    )}
                  </>
                )}

                {(values[fields.feeRunType] === 2 ||
                  (values[fields.feeRunType] === 1 &&
                    values[fields.feeProcess] === 2)) && (
                  <>
                    <div className="addedPlans-card-font mb-10">
                      Process Time
                    </div>
                    <TimePicker
                      setFieldValue={setFieldValue}
                      values={values}
                      fields={fields}
                      errorMsg={errorMsg}
                      disabled={isEdit && !isSave}
                    />
                  </>
                )}
              </ManageFeeLayout>
            </Form>
          );
        }}
      </Formik>
    </LoaderWrapper>
  );
};
export default ScheduleRunContainer;
